export default "__VITE_ASSET__lwU1kNIu__"